<template>
    <dialog-template v-bind="$attrs"
        @update:visible="handleVisible"
        :visible="true"
        :width="'828px'">
        <div class="fx-v-center" slot="title">
            <h1 class="fs-16 fw-600 color-333">系统提醒</h1>
        </div>
        <template v-if="cardTableData.length">
            <h2 class="color-333 fs-14 fw-600 lh-30 align-c">下列会员导入失败，原因是系统内已存在同卡号会员，请修改后导入</h2>
            <el-table :data="cardTableData" :max-height="240">
                <el-table-column
                    label="#"
                    width="50">
                    <template v-slot="{ $index }">
                        <p>{{ $index + 1 }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="会员姓名"
                    width="180">
                    <template v-slot="{ row }">
                        <user-info :userInfo="{
                            avatar: get(row, 'user.avatar'),
                            nickname: get(row, 'user.nickname'),
                            realname: get(row, 'realname') || get(row, 'name'),
                            gender: get(row, 'user.gender')
                        }" />
                    </template>
                </el-table-column>
                <el-table-column 
                    label="手机号"
                    width="110"
                    align='center'>
                    <template v-slot="{ row }">
                        <p>{{ row.phone || '-' }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="生日"
                    width="110"
                    align='center'>
                    <template v-slot="{ row }">
                        <p>{{ row.birthday || '-' }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="余额(元)"
                    width="94"
                    align="center">
                    <template v-slot="{ row }">
                        <p>{{ row.balance || '-' }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="积分"
                    width="90"
                    align="center">
                    <template v-slot="{ row }">
                        <p>{{ row.point || '-' }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="会员卡号"
                    width="160"
                    align="center">
                    <template v-slot="{ row }">
                        <p>{{ row.card_code || '-' }}</p>
                    </template>
                </el-table-column>
                <el-table-column width="10" />
            </el-table>
        </template>
        <template v-if="oldTableData.length">
            <h2 class="color-333 fs-14 fw-600 mt-12 lh-30 align-c">下列会员导入失败，原因是您的店铺已开启新老系统会员同步，老系统已存在该会员，为防止导入后数据混乱，暂不支持导入</h2>
            <el-table :data="oldTableData" :max-height="240">
                <el-table-column
                    label="#"
                    width="50">
                    <template v-slot="{ $index }">
                        <p>{{ $index + 1 }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="会员姓名"
                    width="180">
                    <template v-slot="{ row }">
                        <user-info :userInfo="{
                            avatar: get(row, 'user.avatar'),
                            nickname: get(row, 'user.nickname'),
                            realname: get(row, 'realname') || get(row, 'name'),
                            gender: get(row, 'user.gender')
                        }" />
                    </template>
                </el-table-column>
                <el-table-column 
                    label="手机号"
                    width="110"
                    align='center'>
                    <template v-slot="{ row }">
                        <p>{{ row.phone || '-' }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="生日"
                    width="110"
                    align='center'>
                    <template v-slot="{ row }">
                        <p>{{ row.birthday || '-' }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="余额(元)"
                    width="94"
                    align="center">
                    <template v-slot="{ row }">
                        <p>{{ row.balance || '-' }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="积分"
                    width="90"
                    align="center">
                    <template v-slot="{ row }">
                        <p>{{ row.point || '-' }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="会员卡号"
                    width="160"
                    align="center">
                    <template v-slot="{ row }">
                        <p>{{ row.card_code || '-' }}</p>
                    </template>
                </el-table-column>
                <el-table-column width="10" />
            </el-table>
        </template>
        <div class="fx-center" slot="footer">
            <el-button type="primary" size="medium" :loading="isConfirmLoading" @click="confirm()">确认</el-button>
        </div>
    </dialog-template>
</template>

<script lang="tsx">
import { createComponent, ref, computed, onBeforeMount, onMounted } from '@vue/composition-api'
import get from 'lodash/get'

export default createComponent({
    props: {
        repeatCardData: {
            type: Array,
            default: () => []
        },
        repeatOldData: {
            type: Array,
            default: () => []
        }
    },

    setup: (props, ctx) => {
        const isConfirmLoading = ref(false)
        const cardTableData = computed(() => {
            let resultArr: any = []
            props.repeatCardData && props.repeatCardData.map((item: any) => {
                if (item !== null) {
                    resultArr.push(item.imported_member)
                }
            })
            return resultArr
        })
        const oldTableData = computed(() => {
            let resultArr: any = []
            props.repeatOldData && props.repeatOldData.map((item: any) => {
                if (item !== null) {
                    resultArr.push(item.imported_member)
                }
            })
            return resultArr
        })

        function handleVisible() {
            ctx.emit('close')
        }

        async function confirm() {
            ctx.emit('close')
        }

        return {
            isConfirmLoading,
            cardTableData,
            oldTableData,
            get,
            handleVisible,
            confirm
        }
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-radio__label {
    display: none;
}

::v-deep .el-table tr {
    cursor: pointer;
}

.select-result {
    .table {
        height: 44px;
        line-height: 44px;
        padding: 0 10px 0 20px;
        border: 1px solid #ebebeb;
        box-sizing: border-box;
        margin-left: 38px;
        color: #333;

        &:hover {
            background-color: #f7f7f7;
        }

        ::v-deep .user-info {
            width: 154px !important;
            margin-right: 16px;
        }

        span {
            display: inline-block;

            &:nth-child(2),
            &:nth-child(3) {
                width: 110px;
            }
            &:nth-child(4) {
                width: 94px;
            }
            &:nth-child(5) {
                width: 90px;
            }
            &:nth-child(6) {
                width: 160px;
            }
        }
    }
}
</style>
